import {SquareButton} from "@/scenes.ui/square-button";
import {Keys} from "@/constants/key";
import TextUtils from "@/utils/text-utils";
import {Scene} from "phaser";
import SContainer from "@/cmp/s-container";
import BaseSound = Phaser.Sound.BaseSound;
import {Fonts} from "@/constants/font";
import CU from "@/utils/c-u";
import {Tr} from "@/i18n/i18n";

export class BuyButton extends SContainer {

    constructor(scene: Scene, x: number, y: number, oldPrice: number, price: number, clickSound: BaseSound, callback: () => unknown) {
        super(scene, x, y);

        let buyButton = new SquareButton(this.scene, 0, 0, 0, Keys.UI_ART_GREEN_BUTTON,
            undefined, Keys.IC_100_MITHRIL, Tr('t.p'), false);

        buyButton.setCallback(() => {
            callback();
        });
        this.add(buyButton);

        let buyPriceText;
        if (oldPrice === price) {
            buyPriceText = TextUtils.addText(scene,
                TextUtils.formatGems(price), 0, 40, '#ffffff', 18, 'bold', 200);
        } else {
            buyPriceText = TextUtils.addTextAdvanced(scene, TextUtils.formatGems(price), 0, 40,
                '#0cff00', 19, 'normal', 200, 'center', 2, Fonts.MYRIADPRO_BOLD);

            buyPriceText.setShadow(0, 0, '#ffffff');
            buyPriceText.setStroke('#000000', 2);
        }
        this.add(buyPriceText);

        if (oldPrice !== price) {
            let oldPriceText = TextUtils.addTextAdvanced(scene, TextUtils.formatGems(oldPrice), 0, 8,
                '#ffffff', 13, 'normal', 200, 'center', 2, Fonts.MYRIADPRO_REGULAR);
            oldPriceText.setShadow(0, 0, '#ffffff');
            oldPriceText.setStroke('#000000', 2);

            // TextUtils.addText(scene,
            // String(oldPrice), 492, 118, '#d0d0d0', 14, 'normal', 200);

            let underline = scene.add.line(0, 0,
                oldPriceText.getLeftCenter().x! + 18 * CU.S, oldPriceText.getLeftCenter().y!,
                oldPriceText.getRightCenter().x! + 14 * CU.S, oldPriceText.getRightCenter().y! + 14 * CU.S, 0xFF0000, 1);

            this.add([oldPriceText, underline]);
        }
    }
}